import { SaveRecipeInputBase } from '../../../models/SaveRecipeInputBase';

export class SaveRecipeInput extends SaveRecipeInputBase {
  customerName: string;
  customerEmail: string;
  orderId: number;
  recipeId?: number;
}